import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

const acceptedFormats = {
  "audio/mpeg": [".mp3"],
  // "audio/m4a": [".m4a"],
  "audio/wav": [".wav"],
  "audio/flac": [".flac"],
  // "audio/ogg": [".ogg"],
  // "audio/aiff": [".aiff"],
};

const MixesFileUpload = ({ onFileSelect }) => {

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;
      // Pass all selected files to the parent
      onFileSelect(acceptedFiles);
    },
    [onFileSelect]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: acceptedFormats,
    // multiple: true,
  });

  return (
    <>
      <div className="w-full max-w-[360px] mx-auto" data-tour="upload-section">
        <div
          {...getRootProps()}
          className={`relative border-2 border-dashed border-[#FA6138] rounded-full aspect-square p-8
          bg-[#741F45]
          transition-all duration-300 cursor-pointer
          hover:border-[#ff724d] group`}
        >
          <input {...getInputProps()} />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
            <img
              src={require("../../../../assets/images/icons/upload-icon.png")}
              alt="Upload"
              className="block w-[50px]"
            />
            <div className="mt-4">
              <p className="text-white text-sm mb-4">
                Accepted file formats:
                <br />
                <span className="font-medium">
                  MP3, WAV, FLAC
                </span>
              </p>

              <button
                className="bg-[#FA6138] text-white px-8 py-3 rounded-full 
            hover:bg-[#ff724d] transition-colors duration-300 mb-4"
              >
                Upload track now
              </button>

              <p className="text-white text-sm opacity-80">
                Your track will be securely analyzed
                <br />
                to generate a free mix preview.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MixesFileUpload;
